/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import {
	Dialog,
	DialogContent,
	DialogTitle,
	Button,
	DialogActions,
	Box,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	Typography
} from "@material-ui/core";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import lod_ from "lodash";
import { useDispatch, useSelector } from "react-redux";

/**
 * Form specific: Build input with type and options given
 */
function FormModerationAvis({ code, actionObject, handleClose, handleSubmit }) {
	const [open, setOpen] = React.useState(true);
	const [openFormReport, setOpenFormReport] = React.useState(false);
	const [alreadyReport, setAlreadyReport] = React.useState(false);
	const [comment, setComment] = useState("");
	const [reason, setReason] = useState("");
	const [listOfReason, setListOfReason] = useState(actionObject?.config.reasons ?? []);

	const { selectedConversation } = useSelector(state => state.cockpit);

	useEffect(() => {
		if (
			selectedConversation?.header?.subtype === "reviewService" &&
			!lod_.isNil(actionObject?.config?.reasonsReview) &&
			!lod_.isEmpty(actionObject?.config?.reasonsReview)
		) {
			setListOfReason(actionObject?.config?.reasonsReview);
		} else if (
			selectedConversation?.header?.subtype === "reviewProduct" &&
			!lod_.isNil(actionObject?.config?.reasonsProduct) &&
			!lod_.isEmpty(actionObject?.config?.reasonsProduct)
		) {
			setListOfReason(actionObject?.config?.reasonsProduct);
		} else {
			setListOfReason([]);
		}

		const checkMessage = selectedConversation?.messages.find(
			message => message?.header?.source !== "contact"
		);
		const checkState = selectedConversation?.meta?.review?.report;

		if (!lod_.isNil(checkMessage) || !["AV2"].includes(selectedConversation?.header?.channel)) {
			setOpenFormReport(true);
		} else {
			setOpenFormReport(false);
		}

		if (!lod_.isNil(checkState) && checkState === true) {
			setAlreadyReport(true);
		} else {
			setAlreadyReport(false);
		}
	}, []);

	return (
		<div>
			<Dialog
				fullWidth={true}
				onClose={handleClose}
				maxWidth={"sm"}
				open={open}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">{`Signalement de l'avis`}</DialogTitle>
				<DialogContent dividers>
					{openFormReport === false || alreadyReport === true ? (
						<Box style={{ display: "flex", justifyContent: "center" }}>
							<Typography>
								{alreadyReport
									? `L'avis à déja été signalé`
									: `Veuillez répondre à l'avis pour effectuer un signalement`}
							</Typography>
						</Box>
					) : (
						<Box>
							<Box paddingBottom={2}>
								<FormControl variant="outlined" fullWidth>
									<InputLabel id="select-label">Motif du signalement</InputLabel>
									<Select
										labelId="select-label"
										id="select"
										label="Motif du signalement"
										value={reason}
										onChange={e => setReason(e.target.value)}
									>
										{listOfReason
											.sort((a, b) => a?.label.localeCompare(b?.label))
											.map((code, index) => (
												<MenuItem key={index} value={code.code}>
													- {code.label}
												</MenuItem>
											))}
									</Select>
								</FormControl>
							</Box>

							<Box>
								<TextField
									fullWidth
									minRows={6}
									maxRows={6}
									multiline
									id="standard-required"
									name={`orderTest.other.agentComments`}
									label={i18n.t("OrderForm.agentComments")}
									variant="outlined"
									value={comment}
									onChange={e => setComment(e.target.value)}
								/>
							</Box>
						</Box>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} style={{ margin: "2%" }} color="secondary">
						{i18n.t("CD.cancel")}
					</Button>
					<Button
						onClick={() =>
							handleSubmit(
								{
									comment,
									reason,
									queueAction: actionObject?.config?.queueAction,
									review: { reviewID: selectedConversation?.header?.extra?.externalInfos?.fID }
								},
								code,
								actionObject
							)
						}
						style={{ margin: "2%" }}
						color="primary"
						disabled={lod_.isEmpty(comment) || lod_.isEmpty(reason)}
					>
						{i18n.t("CD.validate")}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default FormModerationAvis;
